module.exports = __webpack_public_path__ + "img/usage3.01a90f56.png";